var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"{ name: 'Home', params: { lang: this.$i18n.locale }}"}},[_vm._v(_vm._s(_vm.$t('pages_routes.home'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }